import { useState, useEffect } from 'react';
import { isPetsureUnderwriter } from '../helpers/paymentHelper';

// Validate instalment if ready to be process for real time payment
const useUpdateTransactionsData = (petDetails, outstandingPaymentDetails, validateOutstandingPayment) => {
  const [enrichOutstandingPayment, setEnrichOutstandingPayment] = useState([]);
  useEffect(() => {
    if (outstandingPaymentDetails && outstandingPaymentDetails.length > 0) {
      const updateTransactions = async () => {
        const filteredOutstandingPayment = outstandingPaymentDetails.filter((item) => item.Message !== 'Not Found');
        if (filteredOutstandingPayment && filteredOutstandingPayment.length > 0) {
          const updatedTransactions = await Promise.all(
            filteredOutstandingPayment?.map(async (transaction) => {
              const updatedPremiumInstallments = await Promise.all(
                transaction?.PremiumInstallment?.map(async (installment) => {
                  const requestPayload = {
                    Amount: installment.DueAmount,
                    CustomerId: installment.CustomerId,
                    PolicyNumber: installment.PolicyNumber,
                    LineNumber: installment.InstalmentLineNumber
                  };
                  const response = await validateOutstandingPayment(requestPayload);
                  const isValid = response?.data?.responseObject ?? false;
                  return {
                    ...installment,
                    isValid,
                    isSelected: false
                  };
                })
              );
              // Sort PremiumInstallments by InstalmentNumber
              const sortedPremiumInstallments = updatedPremiumInstallments?.sort(
                (a, b) => a.InstalmentNumber - b.InstalmentNumber
              );

              return {
                ...transaction,
                PremiumInstallment: sortedPremiumInstallments,
                IsPetSureUnderwriter: isPetsureUnderwriter({ petDetails, policyNumber: transaction.PolicyNumber })
              };
            })
          );
          setEnrichOutstandingPayment(updatedTransactions);
        }
      };
      updateTransactions();
    }
  }, [petDetails, outstandingPaymentDetails, validateOutstandingPayment]);
  return enrichOutstandingPayment;
};

export { useUpdateTransactionsData };
